import React, { PureComponent } from 'react';
import { Row, Col } from 'reactstrap'; //Card, CardTitle, CardText, CardBody, Col
import { withApollo } from 'react-apollo';
import { GetPlaybook, UpdatePlaybook } from '../../queries/playbook'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { signout } from '../../redux/actions/userActions';

class HIPAAPlaybookContent extends PureComponent {
    constructor(props) {
        super(props);

        this._isMounted = false;
    }

    state = {
        playbookData: null,
        playbookDataString: '',
        loadedPlaybook: false,
        loadingPlaybook: true,
        saved: false,
        validateError: null
    }

    componentWillMount () {
        this._isMounted = false;
        return this.props.user ? null : this.props.history.push('/unauthorized')
    }

    async componentDidMount () {
        this._isMounted = true;
        try {
            if (this._isMounted) {
                const { data: playbookData } = await this.props.client.query({
                    query: GetPlaybook(),
                    fetchPolicy: 'network-only',
                    variables: { playbookData: { framework: 'hipaa' } }
                })

                if (playbookData && playbookData.compliancePlaybook) {
                    this.setState({
                        playbookData: JSON.parse(playbookData.compliancePlaybook.playbook),
                        playbookDataString: playbookData.compliancePlaybook.playbook,
                        loadedPlaybook: true,
                        loadingPlaybook: false
                    });
                } else {
                    this.setState({ loadedPlaybook: true, loadingPlaybook: false });
                }
            }
        } catch (err) {
            console.log(err.message)
            this.setState({ loadedPlaybook: true, loadingPlaybook: false });
        }
    }

    updatePlaybook = async () => {
        try {
            JSON.parse(this.state.playbookDataString);
            await this.props.client.mutate({
                mutation: UpdatePlaybook(),
                fetchPolicy: 'no-cache',
                variables: {
                    playbookData: {
                        framework: 'hipaa',
                        playbook: this.state.playbookDataString
                    }
                }
            })
            this.setState({ saved: true }, () => {
                const self = this;
                setTimeout(function () {
                    self.setState({ saved: false })
                }, 2000);
            });
        } catch (err) {
            console.log('Saving Error')
            console.log(err.message)
        }
    }

    formatJSON = () => {
        try {
            var ugly = document.getElementById('json-data').value;
            var obj = JSON.parse(ugly);
            var pretty = JSON.stringify(obj, undefined, 4);
            document.getElementById('json-data').value = pretty;
            
        } catch (e) {
            console.log(e.message)
            this.setState({ validateError: e.message }, () => {
                const self = this;
                setTimeout(function () {
                    self.setState({ validateError: null })
                }, 5000);
            });
        }
    }

    render () {
        const loadingComponent = <Row>
            <div className='custom_load load'>
                <div className='load__icon-wrap'>
                    <svg className='load__icon'>
                        <path fill='#2d9aa6' d='M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z' />
                    </svg>
                </div>
            </div>
        </Row>

        return (
            !this.state.loadedPlaybook ? loadingComponent :
                <div className="content-container">
                    <Row>
                        <div className="content__high_level_category">
                            <Row>
                                <Col md={12} id='hipaaPlaybookHeading'>
                                    <h3 className='page-title'>HIPAA Playbook Data</h3>
                                    <h3 className='page-subhead subhead'>
                                        <strong>Modify the HIPAA Playbook data here</strong>
                                    </h3>
                                </Col>
                            </Row>
                            <Row>
                                <div className='form__form-group-field'>
                                    <textarea
                                        id='json-data'
                                        rows="50"
                                        cols="180"
                                        value={this.state.playbookDataString}
                                        onChange={(e) => {
                                            try {
                                                this.setState({ playbookDataString: e.target.value });
                                            } catch (e) {
                                                console.log(e)
                                            }
                                        }}
                                    />
                                </div>
                                {
                                    this.state.saved ?
                                        <p
                                            style={{
                                                fontWeight: 'bold',
                                                padding: 10,
                                                justifyContent: 'center',
                                                alignItems: "center",
                                                margin: '30px auto'
                                            }}>Saved!</p>
                                        :
                                        <button
                                            style={{ margin: '30px auto' }}
                                            className='btn btn-primary account__btn'
                                            onClick={() => {
                                                this.updatePlaybook()
                                            }}>
                                            Publish
                                </button>
                                }
                                {
                                    this.state.validateError ?
                                        <p
                                            style={{
                                                fontWeight: 'bold',
                                                padding: 10,
                                                justifyContent: 'center',
                                                alignItems: "center",
                                                margin: '30px auto'
                                            }}>{this.state.validateError}</p>
                                        :
                                        <button
                                            style={{ margin: '30px auto' }}
                                            className='btn btn-warning account__btn'
                                            onClick={() => {
                                                this.formatJSON()
                                            }}> Validate </button>
                                }
                            </Row>
                        </div>
                    </Row>
                </div>
        )
    }

}

function mapStateToProps (state) {
    return {
        user: state.auth.user,
        enabledFrameworks: state.controlsData.enabledFrameworks,
        dataLoaded: !state.controlsData.loading,
        sidebar: state.sidebar
    }
}

export default withApollo(connect(mapStateToProps, { signout })(withRouter(HIPAAPlaybookContent)));


// WEBPACK FOOTER //
// ./src/components/content_management/HIPAAPlaybookContent.js